// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".terms[data-v-fa980168]{font-size:.85em;width:100%}.terms.sidebar[data-v-fa980168],.terms.sidebar a[data-v-fa980168]{color:#bbb}.terms[data-v-fa980168]:not(.sidebar){padding:10px 20px}.terms[data-v-fa980168]:not(.sidebar),.terms:not(.sidebar) a[data-v-fa980168]{color:#2b2b2b}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
